// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file shifts/end_shift_system.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.EndShiftSystemRequest
 */
export class EndShiftSystemRequest extends Message<EndShiftSystemRequest> {
  /**
   * @generated from field: string shift_id = 1;
   */
  shiftId = "";

  /**
   * @generated from field: float cash_drawer_end_amount = 2;
   */
  cashDrawerEndAmount = 0;

  /**
   * @generated from field: float card_end_amount = 3;
   */
  cardEndAmount = 0;

  /**
   * @generated from field: float payouts = 4;
   */
  payouts = 0;

  constructor(data?: PartialMessage<EndShiftSystemRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.EndShiftSystemRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shift_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cash_drawer_end_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "card_end_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "payouts", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndShiftSystemRequest {
    return new EndShiftSystemRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndShiftSystemRequest {
    return new EndShiftSystemRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndShiftSystemRequest {
    return new EndShiftSystemRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EndShiftSystemRequest | PlainMessage<EndShiftSystemRequest> | undefined, b: EndShiftSystemRequest | PlainMessage<EndShiftSystemRequest> | undefined): boolean {
    return proto3.util.equals(EndShiftSystemRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.EndShiftSystemResponse
 */
export class EndShiftSystemResponse extends Message<EndShiftSystemResponse> {
  constructor(data?: PartialMessage<EndShiftSystemResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.EndShiftSystemResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndShiftSystemResponse {
    return new EndShiftSystemResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndShiftSystemResponse {
    return new EndShiftSystemResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndShiftSystemResponse {
    return new EndShiftSystemResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EndShiftSystemResponse | PlainMessage<EndShiftSystemResponse> | undefined, b: EndShiftSystemResponse | PlainMessage<EndShiftSystemResponse> | undefined): boolean {
    return proto3.util.equals(EndShiftSystemResponse, a, b);
  }
}

